export const coursesEN = {
  unit: 'Unit {{value}}',
  units: 'Unidades',
  title: 'Choose your package and start now!',
  inscription: 'Enrolling into the course..',
  sidebar: {
    classes: 'Online Classes'
  }
}
